/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'news-feed-asset-other': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="currentColor" stroke-width="2" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M0 7h5v6H0zM9 7h4a4 4 0 014 4v4H9V7zM28 22a2 2 0 102-2M8 10H6"/><path pid="1" d="M6 7h23l3 3H18M25.5 6.5L12 0 2 6.5M5 30h14M10 16v13M14 16v13"/><path pid="2" d="M9 6l3-5.5L14.5 6M30 11v8"/></g>'
  }
})
